<!-- 抽奖券获取 -->
<template>
  <div :class="$style['lottery-ticket']">
    <h2>抽奖券获取<span>（以下任务达成后均获取1张抽奖券，共计4张）</span></h2>
    <ul>
      <li>
        将此页面分享给好友抽奖券+1
        <!-- 分享按钮 -->
        <btn-share
          :disabled="completeLottery"
          request-share
          add-lottery-count
          :btn-class="`${$style['btn-lottery']}${!completeShare ? ` ${$style['red-dot']}` : ''}`"
          @before-click="checkLogin"
          @custom-click="handleShareClick"
        />
      </li>
      <li>
        队伍人数达3/5人全队各得抽奖券+1
        <button
          :disabled="completeLottery"
          :class="[$style['btn-lottery'], !completeLottery && $style['red-dot']]"
          @click="onLottery"
        />
      </li>
      <li>
        签到{{ signinGetLotteryTicketDay }}次抽奖券+1
        <button
          :disabled="completeLottery"
          :class="[$style['btn-lottery'], !completeLottery && $style['red-dot']]"
          @click="onLottery"
        />
      </li>
    </ul>
    <!-- 邀请提示 -->
    <popup-frame ref="invite-tip" size="mini">
      <p style="margin-bottom: 0.5rem; font-size: 0.34rem; font-family: 'Source Han Serif SC Bold'">
        是否邀请好友加入队伍一起领好礼？
      </p>
      <invite-link @copy-success="closeInviteTip">
        <template #trigger>
          <button :class="$style['btn-invite']" />
        </template>
      </invite-link>
    </popup-frame>

    <!-- 签到弹出提示 -->
    <popup-frame ref="signin-tip" size="mini">
      <p
        style="
          padding: 0 0.5rem;
          font-size: 0.32rem;
          font-family: 'Source Han Serif SC Bold';
          line-height: 1.8;
        "
      >
        签到
        {{ signinGetLotteryTicketDay }}
        次还可领取1张抽奖券喔~<br />团长记得在活动时间内完成签到领奖励~
      </p>
    </popup-frame>
  </div>
</template>

<script>
import { BtnShare, PopupFrame } from '@/components/widgets'
import InviteLink from '../InviteLink'
import { mapGetters } from 'vuex'

export default {
  name: 'LotteryTicket',
  components: {
    BtnShare,
    PopupFrame,
    InviteLink
  },
  computed: {
    ...mapGetters([
      'teamMemberList',
      'isBindRole',
      'lotteryCount',
      'completeShare',
      'completeLottery',
      'signinDays',
      'signinGetLotteryTicketDay'
    ])
  },
  methods: {
    handleShareClick() {
      if (this.completeShare) {
        this.onLottery()
        return false
      } else {
        return true
      }
    },
    onLottery() {
      if (!this.isBindRole) {
        this.$emit('login')
        return
      }

      // 玩家没有组队，弹窗提示
      if (this.teamMemberList.length === 0) {
        this.$emit('no-team')
        return
      }

      // 队伍人数不足5人，弹窗提示
      if (this.teamMemberList.length !== 5) {
        this.showInviteTip()
        return
      }

      // 队伍人数已满，但签到天数不足指定天数，弹窗提示
      if (this.teamMemberList.length === 5 && this.signinDays < this.signinGetLotteryTicketDay) {
        this.$refs['signin-tip'].show()
        return
      }

      // 跳转抽奖
      this.$emit('go-lottery')
    },
    showInviteTip() {
      this.$refs['invite-tip'].show()
    },
    closeInviteTip() {
      this.$refs['invite-tip'].hide()
    },
    checkLogin() {
      if (!this.isBindRole) {
        this.$emit('login')
        return false
      }
      return true
    }
  }
}
</script>

<style lang="less" module>
.lottery-ticket {
  h2 {
    padding-left: 1.35rem;
    font-size: 0.3rem;
    font-family: 'Source Han Serif SC Bold';
    line-height: 1.5;
    color: #f7ca82;

    span {
      font-size: 0.18rem;
      color: #fee489;
    }
  }

  ul {
    width: 6.12rem;
    margin: 0.26rem auto 0;
  }

  li {
    .size(100%, 0.95rem);
    .background-fill('./images/lottery-ticket-bg.png');

    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.2rem;
    padding: 0 0.35rem 0 0.6rem;
    color: #e14d49;

    .btn-receive {
      position: relative;
      top: -0.03rem;
    }
  }
}

.btn-lottery {
  .size(1.36rem, 0.48rem);
  .background-fill('./images/btn-lottery.png', 100% 200%);

  &:disabled {
    background-position: 0 100%;
  }
}

.btn-invite {
  .size(1.95rem, 0.66rem);
  .background-fill('./images/btn-invite.png');
}

.red-dot {
  position: relative;

  &::after {
    .size(0.26rem);
    .background-fill('./images/red-dot.png');

    content: '';
    position: absolute;
    top: -0.07rem;
    right: -0.07rem;
  }
}
</style>
